export default __webpack_public_path__ + "static/media/gaji1.31d2b64d.png";